'use client'

import React, { FC, ReactElement } from 'react'
import Link from 'next/link'

const CustomLink: FC<{
	className?: string
	href?: string
	onClick?: (evt?: any) => void
	children: React.ReactNode
	target?: string
}> = (props): ReactElement => {
	const _onClick = React.useCallback(() => {
		window.scroll(0, 0)
		props?.onClick && props?.onClick()
	}, [props])

	return (
		<Link
			className={props?.className}
			href={props?.href as any}
			onClick={props?.onClick}
			prefetch={false}
			target={props?.target}
		>
			{props.children}
		</Link>
	)
}

export default CustomLink
